import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { withIntl } from '@grandvisionhq/state';
import LensPacksItem from './LensPacksItem/LensPacksItem.js';

class LensPacks extends React.Component {
    render() {
        const { packs , currentBreakpoint , intl  } = this.props;
        const hasBasicClass = packs.length === 6 ? 'lens-packs--has-basic' : '';
        const benefitLabels = packs.length > 0 && packs[0].benefits.map((benefit)=>benefit.label
        ) || [];
        if (currentBreakpoint === MediaQuery.BreakpointName.PHONE || currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE) {
            return /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-accordion"
            }, this.renderItems(), intl.getLabel('products.disclaimer', {
                hideLabelKey: true
            }) !== '' && /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-accordion__disclaimer"
            }, intl.getLabel('products.disclaimer')));
        } else {
            return /*#__PURE__*/ React.createElement("div", {
                className: `lens-packs ${hasBasicClass}`
            }, /*#__PURE__*/ React.createElement("label", {
                className: "lens-packs-column lens-packs-column--labels"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-cell lens-packs-cell--type lens-packs-cell--empty"
            }), /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-cell lens-packs-cell--title lens-packs-cell--empty"
            }), benefitLabels.map((label)=>{
                return /*#__PURE__*/ React.createElement("div", {
                    key: label,
                    className: "lens-packs-cell lens-packs-cell--label"
                }, /*#__PURE__*/ React.createElement("span", null, label));
            }), /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs-cell lens-packs-cell--footer lens-packs-cell--empty"
            })), this.renderItems(), intl.getLabel('products.ssp.voucher.disclaimer', {
                hideLabelKey: true
            }) !== '' && /*#__PURE__*/ React.createElement("div", {
                className: "lens-packs__disclaimer"
            }, intl.getLabel('products.ssp.voucher.disclaimer')));
        }
    }
    constructor(...args){
        super(...args);
        this.onPackChange = (packType)=>{
            this.props.onChange && this.props.onChange(packType);
        };
        this.renderItems = ()=>{
            const { packs , selectedPack , useIncludedLensPack  } = this.props;
            return packs.map((pack)=>{
                if (!pack.packType) {
                    console.error('No packType found');
                    return;
                }
                const price = pack.prices && pack.prices.length && pack.prices[0];
                if (!price) {
                    console.error(`No price found for pack with packType "${pack.packType}"`);
                    return;
                }
                return /*#__PURE__*/ React.createElement(LensPacksItem, {
                    key: pack.id,
                    item: pack,
                    value: pack.packType,
                    price: price,
                    isSelected: pack.packType === selectedPack,
                    onChange: this.onPackChange,
                    useIncludedLensPack: useIncludedLensPack
                });
            });
        };
    }
}
var LensPacks$1 = withIntl(MediaQuery.WithBreakpoints(LensPacks));

export { LensPacks, LensPacks$1 as default };
//# sourceMappingURL=LensPacks.js.map
